import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=a6ebfbf2&scoped=true&lang=pug&"
import script from "./NewUser.vue?vue&type=script&lang=ts&"
export * from "./NewUser.vue?vue&type=script&lang=ts&"
import style0 from "./NewUser.vue?vue&type=style&index=0&id=a6ebfbf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ebfbf2",
  null
  
)

export default component.exports